<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :roles="roles"></router-view>
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  props: {
    roles: {
      type: Array
    }
  },
  data() {
    return {};
  },
  computed: {
    cachedViews() {
      //return this.$store.state.tagsView.cachedViews;
    }
  },
  methods: {},
  created() {}
};
</script>

<style scoped>
.app-main {
  
  background: #fafbfd;
  min-height: calc(100vh - 125px);
  padding-top: 60px;
}
</style>